import { useDebounceValue } from 'usehooks-ts';
import { useMemo, useState, useEffect } from 'react';

import { LibraryTagTreeItem } from 'types';

import { filterTree } from './helpers';

export const useTagTree = (tags: LibraryTagTreeItem[]) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [expanded, setExpanded] = useState<Set<string>>(new Set());
  const [debouncedQuery] = useDebounceValue(searchQuery, 300);

  const { treeItems, matchCount, searchExpandIds } = useMemo(() => {
    if (!debouncedQuery) {
      return { matchCount: 0, treeItems: tags, searchExpandIds: null };
    }

    const { filtered, expandIds, matchCount } = filterTree(
      tags,
      debouncedQuery
    );
    return { matchCount, treeItems: filtered, searchExpandIds: expandIds };
  }, [tags, debouncedQuery]);

  useEffect(() => {
    if (!searchExpandIds) return;
    setExpanded((prev) => {
      const next = new Set(prev);
      for (const id of searchExpandIds) next.add(id);
      return next;
    });
  }, [searchExpandIds]);

  return {
    expanded,
    treeItems,
    matchCount,
    searchQuery,
    setExpanded,
    setSearchQuery,
  };
};
